import { ChangeEventHandler } from 'react'
import { useTheme, Switch, useMediaQuery } from '@mui/material'

import { useStyles } from '../account/account-support/styles'

interface ISettingsSwitchProps {
  checked?: boolean
  handleChange?: ChangeEventHandler<HTMLInputElement>
  name: string
  label: string | JSX.Element
  icon?: React.ReactNode
  disabled?: boolean
}

const SettingsSwitch = ({
  checked,
  handleChange,
  label,
  name,
  icon,
  disabled,
}: ISettingsSwitchProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile_l'))
  const classes = useStyles()

  return (
    <div className={classes.switchWrapper}>
      <div className={classes.switchLabel}>
        {icon && icon}
        <p className={classes.switchLabelText}>{label}</p>
      </div>
      <Switch
        size={isMobile ? 'small' : 'medium'}
        checked={checked}
        onChange={handleChange}
        id={name}
        name={name}
        disabled={disabled}
      />
    </div>
  )
}

export { SettingsSwitch }
